import { render, staticRenderFns } from "./MailChange.vue?vue&type=template&id=0ebfa20f&"
import script from "./MailChange.vue?vue&type=script&lang=js&"
export * from "./MailChange.vue?vue&type=script&lang=js&"
import style0 from "./MailChange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MailChange.vue"
export default component.exports